import { createRequest, RequestConfig } from 'app/common/api';

import { TEmployeeConstraints } from '../core/employee-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_employees',
};

export const getEmployeesRequest = (constraints?: TEmployeeConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
